import SearchEventContainer from "./MainContainer";

function SearchEventPage(){
    return(
        <SearchEventContainer />
    )
}

export default SearchEventPage